import { render, staticRenderFns } from "./PopupVue.vue?vue&type=template&id=4ae8d956&scoped=true"
import script from "./PopupVue.vue?vue&type=script&lang=js"
export * from "./PopupVue.vue?vue&type=script&lang=js"
import style0 from "./PopupVue.vue?vue&type=style&index=0&id=4ae8d956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8d956",
  null
  
)

export default component.exports